import { render } from "./M01AccountAnchor.vue?vue&type=template&id=f984ef40&scoped=true&ts=true"
import script from "./M01AccountAnchor.vue?vue&type=script&lang=ts"
export * from "./M01AccountAnchor.vue?vue&type=script&lang=ts"

import "./M01AccountAnchor.vue?vue&type=style&index=0&id=f984ef40&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f984ef40"]])

export default __exports__